import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { BusinessError } from '@mews/framework/errors';
import { createAction, createReducer } from '@mews/framework/redux';

export const module = ({ prefix, moduleSelector }: $TSFixMe) => {
    const UPDATE_CARD_NUMBER_METADATA = prefix('UPDATE_CARD_NUMBER_METADATA');
    const UPDATE_CVV_METADATA = prefix('UPDATE_CVV_METADATA');
    const CLEAR_METADATA = prefix('CLEAR_METADATA');

    const init =
        ({
            merchantId,
            cardNumberFieldId,
            cardNumberAriaLabel,
            cvvFieldId,
            cvvAriaLabel,
            fieldStyles,
            fontFaceStyles,
        }: $TSFixMe) =>
        (_: $TSFixMe, __: $TSFixMe, { pciProxyService }: $TSFixMe) => {
            pciProxyService.init({
                merchantId,
                cardNumberFieldId,
                cardNumberAriaLabel,
                cvvFieldId,
                cvvAriaLabel,
                styles: {
                    '*': fieldStyles,
                    '@font-face': {
                        '*': fontFaceStyles,
                    },
                },
            });
        };

    const tearDown =
        () =>
        (dispatch: $TSFixMe, __: $TSFixMe, { pciProxyService }: $TSFixMe) => {
            pciProxyService.reset();
            dispatch(clearMetadata());
        };

    const updateCardNumberMetadata = (metadata: $TSFixMe) => createAction(UPDATE_CARD_NUMBER_METADATA, metadata);
    const updateCvvMetadata = (metadata: $TSFixMe) => createAction(UPDATE_CVV_METADATA, metadata);
    const clearMetadata = () => createAction(CLEAR_METADATA);

    const tokenizeCard =
        () =>
        (_: $TSFixMe, __: $TSFixMe, { loggerService, pciProxyService }: $TSFixMe) => {
            const t = (...args: $TSFixMe[]) => loggerService.info('tokenize-card', ...args);

            t('tokenizeCard enter');
            const promise = pciProxyService
                .tokenize()
                .catch((result: $TSFixMe) => {
                    t('Tokenization failed', result);

                    const { error } = result;
                    throw new BusinessError(error);
                })
                .then((result: $TSFixMe) => {
                    t('Tokenization succeeded', result);

                    const { transactionId } = result;
                    return transactionId;
                });

            t('tokenizeCard exit');

            return promise;
        };

    const reducer = createReducer(
        {},
        {
            // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
            [UPDATE_CARD_NUMBER_METADATA]: (state, payload) => ({
                ...state,

                cardNumber: {
                    ...state.cardNumber,
                    ...payload,
                },
            }),
            // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
            [UPDATE_CVV_METADATA]: (state, payload) => ({
                ...state,

                cvv: {
                    ...state.cvv,
                    ...payload,
                },
            }),
            [CLEAR_METADATA]: (state: $TSFixMe) => ({
                ...state,
                cardNumber: {},
                cvv: {},
            }),
        }
    );

    const getCardNumberMetadata = flow(moduleSelector, get('cardNumber'));
    const getCvvMetadata = flow(moduleSelector, get('cvv'));

    return {
        actions: {
            init,
            tearDown,
            updateCardNumberMetadata,
            updateCvvMetadata,
            tokenizeCard,
        },
        reducer,
        selectors: {
            getCardNumberMetadata,
            getCvvMetadata,
        },
    };
};
